import { UserContextSwitcherComponent } from '../../common/components/user-context-switcher/user-context-switcher.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { LinkButtonComponent } from '../../common/components/general/link-button/link-button.component';
import { eLinkButtonTarget } from '../../common/components/general/link-button/link-button.model';
import { MatTabsModule } from '@angular/material/tabs';
import { IconComponent } from '../../common/components/general/icon/icon.component';
import { CacheService } from '../../common/services/cache.service';
import { CACHE_KEYS } from '../../common/constants/cache-keys';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { LoginResults, LoginSelections, LogoutResponse } from '../../login/login.viewmodel';
import { ContentModel } from '../../common/models/content.model';
import { ContentFilterPipe } from '../../common/pipes/content-filter.pipe';
import { COMPONENT_META_DATA } from '../../common/constants/component-meta-data';
import { NotificationsMenuService } from '../notifications-menu/notifications-menu.service';
import { LPMI_ROUTES } from '../../common/constants/routes';
import { LoginService } from '../../login/login.service';
import { ElementsService } from '../../common/services/elements.service';
import { addFragmentAndReload } from '../../common/util/utils';
import { SharedMenuService } from '../shared-menu.service';
import { catchError, finalize, forkJoin, of, throwError } from 'rxjs';
import { GtmEvent } from '../../common/models/gtm-event.model';
import { GtmService } from '../../common/services/gtm/gtm.service';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../common/services/auth/auth.service';

@Component({
  selector: 'nuc-user-menu',
  imports: [MatMenuModule, MatTabsModule, IconComponent, ContentFilterPipe, UserContextSwitcherComponent],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit, OnChanges {
  selectedDealer: string;
  selectedRole: string;
  selectedBusinessLabel: string;
  eLinkButtonTargets = eLinkButtonTarget;
  showEditIcon: boolean = false;
  @Input() displayClass: string;
  @Input() size: string;
  @ViewChild(MatMenuTrigger) profileMenuTrigger!: MatMenuTrigger;
  updatedSelections: LoginSelections;
  @Input() pageContent: ContentModel[];
  loginData: LoginResults;
  LABELS = COMPONENT_META_DATA.HEADER.LABELS.USER_ICON_LABELS;
  @Input() desktopOverlayState: boolean = false;
  @Input() userMenuMobileState: boolean;
  constructor(private cacheService: CacheService, private notificationService: NotificationsMenuService, private loginService: LoginService, private dialog: MatDialog,
    private sharedMenuService: SharedMenuService, private elementsService: ElementsService, private router: Router,
    private renderer: Renderer2, private gtm: GtmService, private authService: AuthService) { }


  // ngOnDestroy(): void {
  //    this.cacheService.removeFromCache(CACHE_KEYS.LOGIN.LANGUAGE);
  //    this.cacheService.clearCache();
  // }

  ngOnInit() {
    this.initializePage();
  }

  initializePage() {
    let loginSelections = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_SELECTIONS);

    this.selectedBusinessLabel = loginSelections?.selectedBusinessLabel.value;
    this.selectedRole = loginSelections?.selectedRole.value;
    this.selectedDealer = loginSelections?.selectedDealer.value;

    this.loginData = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    // if(this.loginData?.isAdmin && this.loginData?.userType === 'LeapMotor'){
    //   this.showEditIcon = false;
    // }
    // if (this.loginData?.hasMultiRole || this.loginData?.hasMultiBusinessOp || this.loginData?.dealerLists?.length > 1 || this.loginData?.isAdmin) {
    //   this.showEditIcon = true;
    // }

    // this.showEditIcon =
    //   !(this.loginData?.isAdmin && this.loginData?.userType === 'LeapMotor') &&
    //   (this.loginData?.hasMultiRole || this.loginData?.hasMultiBusinessOp || this.loginData?.dealerLists.length > 1 || this.loginData?.isAdmin);
  }

  hasMultipleRoles(): boolean {
    return this.loginData?.hasMultiRole || false;
  }

  ngAfterViewInit(): void {
    this.profileMenuTrigger.menuOpened.subscribe(() => {
      document.querySelector('.cdk-overlay-container')?.classList.add('profile-menu-options');
      const profileIcons = document.querySelectorAll('.profile-icon');
      profileIcons.forEach((icon) => icon.classList.add('selected'));
    });
    this.profileMenuTrigger.menuClosed.subscribe(() => {
      setTimeout(() => {
        document.querySelector('.cdk-overlay-container')?.classList.remove('profile-menu-options');
        const profileIcons = document.querySelectorAll('.profile-icon');
        profileIcons.forEach((icon) => icon.classList.remove('selected'));
      }, 100);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userMenuMobileState']) {
      if (!this.userMenuMobileState) {
        this.profileMenuTrigger?.closeMenu();
      }
    }

    if (changes['desktopOverlayState']) {
      this.profileMenuTrigger?.closeMenu();
    }
  }

  onClick(event?: Event): void {
    event?.stopPropagation();
    const gtmEvent = GtmEvent.create("HEADER", 'Header', 'Display::Menu', 'Account Menu');
    this.gtm.pushEvent(gtmEvent);
    // Set the state for the profile menu
    this.sharedMenuService.toggleMenu('profile', this.profileMenuTrigger.menuOpen);
  }

   open() {
    const dialogRef = this.dialog.open(UserContextSwitcherComponent, {
      panelClass: 'user-menu-overlay-container',
      disableClose: true,
      data: { pageContentdata: this.pageContent },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.state) {
        this.updatedSelections = result.updatedSelections;
        this.initializePage();
        addFragmentAndReload();
        // this.router.resetConfig(this.router.config);
        // this.router.navigate([this.router.url]); //reload the same page again.
      }
    });
  }

  onAccountClick() {
    const gtmEvent = GtmEvent.create("HEADER", 'Header', 'Redirection::Internal', 'Account Menu::My Account');
    this.gtm.pushEvent(gtmEvent);
  }

  logOut() {
    this.notificationService.stopNotifications();
    this.loginService.logout()
      .pipe(
        finalize(() => {
          this.cacheService.removeFromCache(CACHE_KEYS.LOGIN.LANGUAGE);
          this.loginService.idpLogout();
        })
      )
      .subscribe({
        next: (response: LogoutResponse) => {
          if (response?.success) {
            console.log('Cache evicted');
          }
        }, error: (err) => {
          console.log('Already logged out');
        }
      });
  }

}
